import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuditorVisitDetailContext } from '../contexts/AuditorVisitDetailContext';

const Services = () => {
  const { t } = useTranslation();
  const { auditorVisit } = useAuditorVisitDetailContext();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <List>
        {!!auditorVisit.services &&
          auditorVisit.services.map((service) => (
            <ListItem key={service.id} sx={{ display: 'flex', justifyContent: 'flex-start' }}>
              <ListItemText
                primaryTypographyProps={{ fontSize: '1.25rem' }}
                secondaryTypographyProps={{ fontSize: '1rem' }}
                primary={service.serviceShowAs}
                secondary={
                  <Box>
                    <Typography sx={{ fontSize: '1rem', fontWeight: '500' }}>
                      {t('Standard', { defaultValue: 'Standard' })}:{' '}
                      {service.processStandard || 'N/A'}
                    </Typography>
                    {/* <Typography>
                      {t('Note', { defaultValue: 'Note' })}: {service.note || 'N/A'}
                    </Typography> */}
                    <Typography>
                      {t('Scope of work', { defaultValue: 'Scope of work' })}:{' '}
                      {service.scopeOfWork || 'N/A'}
                    </Typography>
                    <Typography>
                      {t('Scope confirmed', { defaultValue: 'Scope confirmed' })}:{' '}
                      {service.scopeConfirmed || 'N/A'}
                    </Typography>
                    {service?.scopeNotes && (
                      <Typography>
                        {t('Scope notes', { defaultValue: 'Scope notes' })}:{' '}
                        {service.scopeNotes || 'N/A'}
                      </Typography>
                    )}
                    {service.srvNotes && (
                      <Typography>
                        {t('Note', { defaultValue: 'Note' })}: {service.srvNotes}
                      </Typography>
                    )}
                  </Box>
                }
              />
            </ListItem>
          ))}
      </List>
    </Box>
  );
};

export default Services;
